// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__GupEm","close":"Alert_close__FuVL-","error":"Alert_error__LKdXG","success":"Alert_success__uDgnx"};